import type { IFileType } from "./fileHelpers";

export async function getImageObjectFromCanvas(
	canvas: HTMLCanvasElement,
	name: string,
	type: string
): Promise<null | IFileType> {
	return new Promise<IFileType | null>((res, _rej) => {
		// Convert canvas to blob and then to File
		canvas.toBlob((blob) => {
			if (!blob) {
				res(null);
				return;
			}
			const resizedFile = new File([blob], name, {
				type: type,
				lastModified: Date.now()
			});
			res(resizedFile);
		}, type);
	});
}

export function getResizedCanvas(canvas: HTMLCanvasElement, newWidth: number, newHeight: number) {
	const tmpCanvas = document.createElement("canvas");
	tmpCanvas.width = newWidth;
	tmpCanvas.height = newHeight;

	const ctx = tmpCanvas.getContext("2d");
	if (!ctx) return null;
	ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, newWidth, newHeight);
	return tmpCanvas;
}
